import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { TripState } from '../../types/trip.store.type';
import { IconPlus, IconMinus } from '../../assets/icons';
import './UnitAmenities.scss';
import { TranslationUtils } from '../../utils';
import { CategoryIcons } from './CategoryIcons';

export const UnitAmenities: React.FC = () => {
    const unitAmenities = useSelector((store: { trip: TripState }) => store.trip.unit_amenities);
    const [currentOpen, setCurrentOpen] = useState<string>();

    if (!unitAmenities) {
        return null;
    }

    const updateToClosed = (id: string) => {
        const divHeader = document.getElementById(`accordion-heading-${id}`);
        const iconMinus = document.getElementById(`link-collapse-show-${id}`);
        const iconPlus = document.getElementById(`link-collapse-${id}`);
        divHeader?.classList.remove('toggle-active');
        iconMinus?.classList.add('hidden');
        iconPlus?.classList.remove('hidden');
    };

    const updateToOpened = (id: string) => {
        const divHeader = document.getElementById(`accordion-heading-${id}`);
        const iconMinus = document.getElementById(`link-collapse-show-${id}`);
        const iconPlus = document.getElementById(`link-collapse-${id}`);
        divHeader?.classList.add('toggle-active');
        iconMinus?.classList.remove('hidden');
        iconPlus?.classList.add('hidden');
    };

    const toggle = (id: string) => {
        setCurrentOpen(id);
        const shouldOpen = document.getElementById(`accordion-heading-${id}`)?.getAttribute('aria-expanded') === 'true';

        if (currentOpen) {
            updateToClosed(currentOpen);
        }

        if (shouldOpen) {
            updateToOpened(id);
            return;
        }

        updateToClosed(id);
    };

    return (
        <div>
            <p tabIndex={0} className="body-bold-l page-subtitle">
                {TranslationUtils.get('in_the_home')}
            </p>

            <div id="accordion">
                {unitAmenities.map((item, i) => {
                    const icon = CategoryIcons[item.identifier] || CategoryIcons.default;
                    return (
                        <div>
                            <div
                                onClick={() => toggle(`${i}`)}
                                className={`toggle card-header false amenity-item`}
                                id={`accordion-heading-${i}`}
                                data-toggle="collapse"
                                data-target={`#accordion-section-${i}`}
                                aria-expanded="false"
                                aria-controls={`accordion-section-${i}`}
                            >
                                <div className="amenity-category">
                                    <button
                                        onKeyDown={() => toggle(`${i}`)}
                                        onKeyPress={() => toggle(`${i}`)}
                                        id={`button-amenity-${i}`}
                                        onClick={() => toggle(`${i}`)}
                                        className="btn"
                                        data-toggle="collapse"
                                        data-target={`#accordion-section-${i}`}
                                        aria-expanded="false"
                                        aria-controls={`accordion-section-${i}`}
                                    >
                                        <span className="amenity-category">
                                            <span className=" amenity-icon">{icon}</span>
                                            <span className={'body-regular'}>{item.name}</span>
                                        </span>
                                    </button>
                                </div>
                                <div className="toggle-icon">
                                    <a className={'hidden'} id={`link-collapse-show-${i}`}>
                                        <IconMinus className="pointer" />
                                    </a>
                                    <a id={`link-collapse-${i}`}>
                                        <IconPlus className="pointer" />
                                    </a>
                                </div>
                            </div>

                            <div
                                id={`accordion-section-${i}`}
                                className="collapse"
                                aria-labelledby={`accordion-heading-${i}`}
                                data-parent="#accordion"
                            >
                                <div tabIndex={0} className="card-body description-item">
                                    {item.description && (
                                        <div
                                            className="body-regular amenity-description"
                                            dangerouslySetInnerHTML={{ __html: item.description }}
                                        />
                                    )}
                                </div>
                            </div>
                        </div>
                    );
                })}
            </div>
        </div>
    );
};
